import { useStream } from "./StreamContext";
import { StreamerStatus } from "./streamerStatus";
export function useStreamCompat() {
    var status = useStream().status;
    switch (status) {
        case "idle":
            return StreamerStatus.New;
        case "connected":
        case "connecting":
        case "reconnecting":
        case "queued":
        case "rendezvoused":
        case "negotiating":
            return StreamerStatus.Checking;
        case "streaming":
            return StreamerStatus.Connected;
        case "interrupted":
        case "failed":
            return StreamerStatus.Failed;
        case "disconnected":
        case "closed":
        case "withdrawn":
            return StreamerStatus.Disconnected;
        // pixel-stream peut émettre d'autres statuts intermédiaires que ceux
        // listés ci-dessus (ex: "connecting") ; les traiter comme "en cours"
        // plutôt que comme une déconnexion évite de rediriger l'utilisateur
        // vers reload.html en pleine connexion.
        default:
            return StreamerStatus.Checking;
    }
}
